var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('vue-progress-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('v-app',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e260789a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = gwX+
// module chunks = 6